import { render, staticRenderFns } from "./BasicPlan.vue?vue&type=template&id=6d63bdf4&scoped=true"
import script from "./BasicPlan.vue?vue&type=script&lang=js"
export * from "./BasicPlan.vue?vue&type=script&lang=js"
import style0 from "./BasicPlan.vue?vue&type=style&index=0&id=6d63bdf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63bdf4",
  null
  
)

export default component.exports